import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';

//slices
import sidebarSlice from './UI';
// import pollSlice from './Poll/pollSlice';
import slideSlice from './Slides/slidesSlice';
import signalRSlice from './SignalR/signalRSlice';
import workspaceSlice from './Workspace/workspaceSlice';
import presentationSlice from './Presentations/presentationSlice';
import fileStructureSlice from './FileStructure/fileStructureSlice';
import paymentSlice from './Payment/paymentSlice';
import settingSlice from './Settings/settingSlice';
import teamsSlice from './Teams/teamsSlice';
import briefcaseSlice from './Briefcase/briefcaseSlice';
import briefcaseTabSlice from './Briefcase/briefcaseTabSlice';
import presentationDSlice from './generics/presenationDSlice';
import sharedBriefcaseSlice from './sharedBriefcase/sharedBriefcaseSlice';
import eventsSlice from './Events/EventsSlice';
import pollSlice from './Poll/pollSlice';
import pollCopySlice from './PollCopy/pollCopySlice';
import onGoingActionSlice from './OnGoing/onGoingAction';
import agendaEventSlice from "./Events/agenda-slice";
import agendaDrawerSlice from "./Events/agenda-drawer"

// Combine all reducers
const appReducer = combineReducers({
  poll: pollSlice,
  teams: teamsSlice,
  slides: slideSlice,
  signalR: signalRSlice,
  settings: settingSlice,
  briefcase: briefcaseSlice,
  workspace: workspaceSlice,
  sidebarState: sidebarSlice,
  paymentState: paymentSlice,
  presentations: presentationSlice,
  fileStructure: fileStructureSlice,
  briefcaseTab: briefcaseTabSlice,
  presentationDSlice: presentationDSlice,
  sharedBriefcase: sharedBriefcaseSlice,
  events: eventsSlice,
  pollcopy: pollCopySlice,
  onGoingActionSlice: onGoingActionSlice,
  agendaSlice: agendaEventSlice,
  agendaDrawerSlice: agendaDrawerSlice
});

// Root reducer that handles the RESET action
const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_ALL') {
    // Reset state to undefined, which causes reducers to return their initial state
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
